export enum AV_TYPES {
  OV = 'OV',
  INCLUSIVE = 'inclusive',
  OPTIONAL = 'optional',
  FIXED = 'fixed',
  MISCONFIGURED = 'misconfigured',
  PACKAGE_MARGIN = 'package_margin',
}

export enum DATE_FORMATS {
  DATE = "DD.MM.YYYY",
  DATE_TIME = "DD.MM.YYYY HH:mm",
  YEAR_MONTH_DAY = "YYYY-MM-DD",
  // TODO Add rest of date formats to this enum
}

export enum EXTERNAL_SYSTEM {
	SKIDATA = 'Skidata',
	AXESS = 'Axess',
	SBBV3 = 'SBBv3',
	SMEETZ = 'Smeetz',
	INFOSYSTEM = 'InfoSystem',
}

export enum PriceType {
	FIT = 'fit',
	GROUP = 'group',
	GENERIC = 'generic',
}